export default {"src":"/_next/static/media/shuffle.83b0d4c7.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};